// extracted by mini-css-extract-plugin
module.exports = {"bg":"_99551c8aa8--bg--qw0B2","slice":"_99551c8aa8--slice--Arv9b"};